const pluralize = (singular: string, plural: string, amount: number) =>
  amount === 1 ? singular : plural

export default pluralize;